import { useContext } from "react";
import { AnswersContext } from "./AnswersProvider";

export const useAnswers = () => useContext(AnswersContext);
